"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _ = require("../../..");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const OrderValue = ({
  value,
  conditionType
}) => {
  const getIcon = () => {
    switch (conditionType) {
      case 'Complete':
        return (0, _pragma.createFelaElement)(_.CheckboxCheckedIcon, {
          color: "background.aqua",
          size: "small"
        });

      case 'Failed':
        return (0, _pragma.createFelaElement)(_.ErrorCircleIcon, {
          color: "background.yellow",
          size: "small"
        });

      case 'Cancelled':
        return (0, _pragma.createFelaElement)(_.CloseCircleIcon, {
          color: "ui5Alt",
          size: "small"
        });

      default:
        return (0, _pragma.createFelaElement)(_.CheckboxCheckedIcon, {
          color: "background.tan",
          size: "small"
        });
    }
  };

  return (0, _pragma.createFelaElement)(_.View, null, value !== null ? (0, _pragma.createFelaElement)(React.Fragment, null, (0, _pragma.createFelaElement)(_.View, {
    margin: ['none', 'small', 'none', 'none']
  }, getIcon()), (0, _pragma.createFelaElement)(_.Text, {
    variant: "meta",
    color: "text.1"
  }, value)) : (0, _pragma.createFelaElement)(_.LoadingBlock, {
    width: 115,
    height: 32
  }));
};

var _default = OrderValue;
exports.default = _default;
//# sourceMappingURL=OrderValue.js.map